import {observer} from "mobx-react-lite";
import {Field, Form} from "react-final-form";
import React from "react";
import StandalonePopover from "../../components/ui/StandalonePopover";
import {FinalButtonSet, Select} from "../../components/ui/form";
import {DayOffUserStore} from "./store/day-off-user-store";
import {DayOffReasonEnum, DayOffUpdateInput} from "../../generated";
import {formatDayOffReasonEnum} from "./format-day-off-reason-enum";

export const DayOffModal = observer((props: { store: DayOffUserStore }) => {
    const {store} = props;

    return <StandalonePopover
        title={store.selectedDayOff ? 'Update day off' : 'Create day off'}
        noGrid
        closePopover={() => store.closeModal()}
    >
        <Form<DayOffUpdateInput>
            onSubmit={(values) => {
                return store.submit(values)
            }}
            initialValues={
                store.selectedDayOff ? {
                    reason: store.selectedDayOff.reason,
                } : {
                    reason: DayOffReasonEnum.Holiday,
                }
            }
            render={({handleSubmit, pristine, submitting}) =>
                <form className={'day-off-modal'} onSubmit={handleSubmit}>
                    <Field
                        name='reason'
                        label='Reason'
                        placeholder='Select reason'
                        options={Object.values(DayOffReasonEnum)}
                        formatOptions={formatDayOffReasonEnum}
                        component={Select}
                    />
                    <FinalButtonSet submitting={submitting} mode={"RELATIVE"}/>
                </form>}/>
    </StandalonePopover>
})